<template>
  <div
    v-if="cartErrors.length > 0"
    class="bg-red-50 md:bg-transparent border-t md:border-t-0 border-red-200 max-h-[156px] overflow-y-auto divide-y md:divide-y-0 divide-red-100"
  >
    <button
      v-for="(message, index) in cartErrors"
      :key="`v1-error-${index}`"
      type="button"
      role="alert"
      class="w-full flex items-center gap-3 px-4 py-3 text-left text-sm text-red-900 md:justify-center md:text-center md:max-w-3xl md:mx-auto cursor-pointer hover:bg-red-100 md:hover:bg-transparent focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500"
      @click="$emit('error-clicked', message)"
    >
      <ExclamationCircleIcon class="h-5 w-5 text-red-600 flex-shrink-0" />
      <span class="flex-grow md:flex-grow-0 text-red-700">{{ message }}</span>
    </button>
  </div>
</template>

<script>
import { ExclamationCircleIcon } from '@heroicons/vue/solid'

export default {
  name: 'V1CartErrorBanner',
  components: { ExclamationCircleIcon },
  props: {
    cartErrors: {
      type: Array,
      required: true
    }
  },
  emits: ['error-clicked']
}
</script>
